const EventEmitter = require('events').EventEmitter;

const event = new EventEmitter();

const EVENTS = {
    CLEAR_COVER: 0, // 清空引导背景
    END_DRAG_AND_MOVE: 1, // 自己封装的事件，用于判断积木块拖拽完成（因为积木块拖拽完成后会引发其他块产生 move 事件）
    BG_CLICK: 2, // 点击背景浮层
    WORKSPACE_INIT: 3, // workspace init 事件
    VM_INIT: 4, // scratch-vm init
    GAME_EVENT: 'GAME_EVENT',
    GAME_FINISH: 'GAME_FINISH',
    PROJECT_RUN_STOP: 'PROJECT_RUN_STOP',

    //与StepRuntime交互的相关事件，以STEP_为前缀
    STEP_ABORT: 'STEP_ABORT', //强制终止引导
    STEP_CONTINUE: 'STEP_CONTINUE', //继续下一步，可能是下一个action或者step
    STEP_SHOW_TIPS: 'STEP_SHOW_TIPS', //提示我
    STEP_ENTER_GUIDE_MODE: 'STEP_ENTER_GUIDE_MODE', //进入手把手引导模式
    STEP_EXIT_GUIDE_MODE: 'STEP_EXIT_GUIDE_MODE', //退出手把手引导模式
    STEP_GUIDE_FINISH: 'STEP_GUIDE_FINISH', //所有引导步骤结束
    STEP_OPTION_SELECTED: 'STEP_OPTION_SELECTED', //选择题选项被选中
    STEP_SWITCHED_STEP: 'STEP_SWITCHED_STEP', //进入了另一个步骤

    //与lesson交互的相关事件
    TASK_LOAD_MODIFIED_PROJECT: 'TASK_LOAD_MODIFIED_PROJECT', //载入用户自己的项目副本
    TASK_LOAD_INIT_PROJECT: 'TASK_LOAD_INIT_PROJECT', //载入初始项目
    TASK_SAVE_PROJECT_TO_MODIFIED_PROJECT: 'TASK_SAVE_PROJECT_TO_MODIFIED_PROJECT', //将当前项目覆盖到自己的副本
    TASK_BACK_TO_STUDY: 'TASK_BACK_TO_STUDY', //返回到学习模式
    TASK_GUIDE_PROJECT_SAVED: 'TASK_GUIDE_PROJECT_SAVED', //task-guide中到项目保存成功或者保存副本成功

    TASK_SAVE: 'TASK_SAVE', //保存当前任务状态

    SHOW_NEXT_STEP_BTN: 'SHOW_NEXT_STEP_BTN',
    HIDE_NEXT_STEP_BTN: 'HIDE_NEXT_STEP_BTN',
    NEXT_STEP: 'NEXT_STEP',
    RESTUDY_TASK: 'RESTUDY_TASK', // 重新学习任务
    GUIDE_STOP: 'GUIDE_STOP', // 重新学习任务
    INIT_TRAIN_PROJECT_TASK:'INIT_TRAIN_PROJECT_TASK',  //初始化课程练习模式任务
    INIT_PROGRAM_TASK:'INIT_PROGRAM_TASK',  //初始化课程作业任务

    //项目加载完成
    PROJECT_LOADED_FINISH: 'PROJECT_LOADED_FINISH',
    //项目保存完成
    PROJECT_UPDATED_FINISH: 'PROJECT_UPDATED_FINISH',
    //创建项目或副本完成
    PROJECT_CREATED_FINISH: 'PROJECT_CREATED_FINISH',

    UPDATE_PROJECT_ERROR: 'UPDATE_PROJECT_ERROR',

    //取消引导
    CANCEL_GUIDE:'CANCEL_GUIDE',
    NEXT_GUIDE:'NEXT_GUIDE',

    NAV_BACK: 'NAV_BACK', //返回按钮被点击

    // 显示隐藏手机端聊天框
    PHONE_CHATBOX: 'PHONE_CHATBOX',

    // 显示任务说明弹框
    CHAT_SHOW_TASK_MODAL: 'CHAT_SHOW_TASK_MODAL',

    // 显示标准答案
    SHOW_ANSWER_MODE:'SHOW_ANSWER_MODE',
};

export {
    EVENTS
};
window.teachEvent = event;
export default event;
